// import * as Sentry from '@sentry/vue'
import { Module, VuexModule } from 'vuex-module-decorators'
// import { Action, Module, VuexModule } from 'vuex-module-decorators'

// import { MerchantSpringControllerApi } from '@/client/reporting'
// import { i18n } from '@/plugins/i18n'

// const { VUE_APP_BASE_URL } = process.env
// const BASE_URL = VUE_APP_BASE_URL.slice(0, VUE_APP_BASE_URL.length - 1)

// const merchantSpringControllerApi = new MerchantSpringControllerApi(undefined, BASE_URL)

@Module({
  namespaced: true
})
export class ResourcesModule extends VuexModule {
  // @Action({ rawError: true })
  // async fetchProvisioningToken (): Promise<string> {
  //   const userId = this.context.rootGetters['user/id']
  //   const token = this.context.rootGetters['auth/jwt']
  //   try {
  //     const requestOpts = {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${token}`
  //       }
  //     }
  //     return (await merchantSpringControllerApi.fetchProvisioningTokenForUser(userId, requestOpts)).data
  //   } catch (e) {
  //     Sentry.captureException(e)
  //     this.context.dispatch('toasts/addError', i18n.t('pages.errors.422.description'), { root: true })
  //     return Promise.reject(e)
  //   }
  // }
}
